module.exports = __webpack_public_path__ + "static/img/19-唯品会.c89f09e0.png";